<template>
  <div class="company-cell" @click="onClick">
    <div class="img-box">
      <el-image class="cell-image" :src="item.compLogo" cover></el-image>
    </div>

    <div class="comp_name">{{ item.compName }}</div>
    <div class="num">
      共有<span class="blue">{{ item.practiseCount }}</span
      >人作答
    </div>
    <div class="paper">
      共有<span class="blue">{{ item.positionCount }}</span
      >套试题
    </div>
    <div class="btn-xs">
      <a>查看详情</a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'company-cell',
  props: ['item'],
  data() {
    return {
      isHover: false,
    }
  },
  methods: {
    onClick() {
      this.$router.push({
        path: '/practice/company-code',
        query: { compCode: this.item.compCode },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.company-cell {
  width: 250px;
  height: 200px;
  display: inline-block;
  cursor: pointer;
  margin: 10px;
  overflow: hidden;
  text-align: center;
  padding: 10px 10px 0 10px;
  background-color: #fff;
  border: 1px solid #eff0f2;
  &:hover {
    box-shadow: #eff0f2 0px 2px 12px 6px;

    .comp_name {
      color: #29bdb9;
      margin-top: -10px;
    }
    .num {
      display: none;
    }
    .paper {
      display: block;
      margin-bottom: -20px;
    }
    .btn-xs {
      width: 100px;
      margin: auto;
      margin-top: 40px;
      display: block;
    }
    .img-box {
      margin-top: -10px;
      .cell-image {
        padding: 0 !important;
      }
    }
  }
  .comp_name {
    padding: 0px 0 6px 0;
  }
  .num {
    font-size: 14px;
    padding: 10px;
  }
  .paper {
    font-size: 14px;
    display: none;
  }
  .btn-xs {
    display: none;
  }
  .img-box {
    vertical-align: middle;
    height: 80px;
    display: grid;
    .cell-image {
      margin: auto;
      max-width: 150px;
      max-height: 70px;
      text-align: center;
      vertical-align: bottom;
      padding: 10px;
    }
  }

  .blue {
    color: #29bdb9;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/practice/company/company-cell.vue